<template>
  <v-tabs
    v-model="activeTab"
    slider-color="red"
    @input="changeTab"
    dark>
    <v-tab
      key="release"
      ripple>
      UnRelease Fund
    </v-tab>
    <v-tab
      key="unrelease"
      ripple>
      Released Fund
    </v-tab>
    <v-tab-item key="release">
      <v-layout row wrap>
        <v-flex xs12>
          <v-expansion-panel>
            <v-expansion-panel-content>
              <div slot="header">Advance Filter</div>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs12 lg4>
                        <v-text-field label="Imposition Name" v-model="filterData.impositionName" @input="doFiltering"
                                      clearable />
                      </v-flex>
                      <v-flex xs12 lg4>
                        <v-text-field label="Employee Name" v-model="filterData.employeeName" @input="doFiltering"
                                      clearable />
                      </v-flex>

                      <v-flex xs12 lg4>
                        <v-select :items="paginationSizes" label="Item(s) per page"
                                  :value="paginationSize"
                                  @input="setPaginationSize" />
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
        <BTUnreleaseDialog ref="detail" :status="status" @changeP="status = false" @apply="apply"></BTUnreleaseDialog>
        <v-flex xs12 v-if="loaded">
          <v-layout row wrap>
            <v-flex xs12>
              <div class="text-xs-center" v-if="pagination.totalPages > 1">
                <v-pagination :length="pagination.totalPages" v-model="page" @input="gotoPage"></v-pagination>
              </div>
              <h2 class="text-lg-center" v-if="pagination.content.length === 0">No BusinessTrip Unreleased Funds Yet</h2>
            </v-flex>
            <v-flex xs12 v-for="item in pagination.content" :key="item.id">
              <v-card tile>
                <v-layout row align-center class="p-lt-10px">
                  <v-flex xs7 md10 lg11>
                    <h3>
                      {{item.employee.name}} - {{item.employee.job.jobProfileName}} ({{item.employee.nik}}) | {{item.sppd.batchNo}}
                    </h3>
                    <p>
                      {{item.fromdatef}} - {{item.todatef}}
                      | {{item.fromCity.value}} - {{item.toCity.value}}
                      | {{item.impositionName}}
                      | <b> RP. {{item.total | numformat('',0)}}</b>
                    </p>
                  </v-flex>
                  <v-flex xs5 md2 lg1 class="text-xs-center">
                    <v-btn small @click="activedialog(item, true)" color="success">Release</v-btn>
                  </v-flex>
                </v-layout>
              </v-card>
              <br>
            </v-flex>
            <v-flex xs12>
              <div class="text-xs-center" v-if="pagination.totalPages > 1">
                <v-pagination :length="pagination.totalPages" v-model="page" @input="gotoPage"></v-pagination>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 v-else>
          <h2>Loading...</h2>
        </v-flex>
      </v-layout>
    </v-tab-item>
    <v-tab-item key="unrelease">
      <v-layout row wrap>
        <v-flex xs12 v-if="loaded">
          <v-layout row wrap>
            <v-flex xs12>
              <h2 class="text-lg-center" v-if="unreleaseData.length === 0">No BusinessTrip Unreleased Funds Yet</h2>
            </v-flex>
            <v-dialog
              v-model="dialogS"
              max-width="290">
              <v-card>
                <v-card-title class="headline">Confirmation</v-card-title>
                <v-card-text>
                  Are u sure want to unrelease funds?
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="green darken-1"
                    flat="flat"
                    @click="dialogS = false">
                    no
                  </v-btn>

                  <v-btn
                    color="green darken-1"
                    flat="flat"
                    @click="updateRelaseFund">
                    yes
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-flex xs12 v-for="item in unreleaseData" :key="item.id">
              <v-card tile>
                <v-layout row align-center class="p-lt-10px">
                  <v-flex xs7 md10 lg11>
                    <h3>
                      {{item.employee.name}} - {{item.employee.job.jobProfileName}} ({{item.employee.nik}}) | {{item.sppd.batchNo}}
                    </h3>
                    <p>
                      {{item.fromDate | moment('DD MMM YYYY')}} - {{item.toDate | moment('DD MMM YYYY')}}
                      | {{item.fromCity.value}} - {{item.toCity.value}}
                      | {{item.impositionName}}
                      | <b> RP. {{item.receivedFundTotal | numformat('',0)}}</b>
                    </p>
                  </v-flex>
                  <v-flex xs5 md2 lg1 class="text-xs-center">
                    <v-btn small @click="activedialog(item, false)" color="error">UnRelease</v-btn>
                  </v-flex>
                </v-layout>
              </v-card>
              <br>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 v-else>
          <h2>Loading...</h2>
        </v-flex>
      </v-layout>
    </v-tab-item>
  </v-tabs>
</template>
<script>
import Vuex from 'vuex'
import moment from 'moment'
import BTUnreleaseDialog from './BT-UnreleaseDialog'
import numformat from '@/assets/js/accounting.min.js'
import _ from 'lodash'

const btRealizationStore = Vuex.createNamespacedHelpers('BusinessTripRealization/Realization')

export default {
  components: {
    BTUnreleaseDialog
  },
  data () {
    return {
      title: 'Business Trip Unrelease Funds',
      pagination: {},
      unreleaseData: [],
      activeTab: 0,
      status: false,
      dialogS: false,
      selecteditem: {},
      actions: [
        {tooltip: 'Refresh', icon: 'refresh', handler: this.refresh}
      ],
      loaded: false,
      page: 1,
      filterData: {
        impositionName: '',
        employeeName: ''
      }
    }
  },
  computed: {
    paginationSize () {
      return this.$store.getters.paginationSize
    },
    paginationSizes () {
      return this.$store.getters.paginationSizes
    }
  },
  methods: {
    ...btRealizationStore.mapActions({
      getEmployeeRealizationsByOrg: 'getEmployeeRealizationsByOrg'
    }),
    activedialog (item, status) {
      this.selecteditem = item
      if (status) {
        this.$refs.detail.$refs.reqdate.setdatetime()
        this.$refs.detail.data.totalf = numformat.formatMoney(item.total, '', 0, '.', ',')
        this.$refs.detail.data.funds = numformat.formatMoney((item.total * 1), '', 0, '.', ',')
        this.status = true
      } else {
        this.dialogS = true
      }
    },
    changeTab (value) {
      if (value === '1' && this.unreleaseData.length === 0) {
        this.getUnreleaseData()
      }
    },
    apply (data) {
      this.selecteditem.receivedFund = true
      this.selecteditem.receivedFundDate = data.date
      this.selecteditem.receivedFundNote = data.note
      this.selecteditem.rate = data.rate
      this.selecteditem.receivedFundTotal = numformat.unformat(data.funds, ',')
      this.$backend.businessTripRequestEmployee.updateBtRequestEmployeeUsingPUT(
        {
          id: this.selecteditem.sppd.id,
          empid: this.selecteditem.id,
          emp: this.selecteditem
        })
        .then(res => {
          this.status = false
          this.loadData()
          this.$refs.detail.clear()
        })
        .catch(err => {
          this.$error(err)
        })
    },
    loadData () {
      this._doFiltering()
    },
    refresh () {
      this._doFiltering()
      this._getUnreleaseData()
    },
    _setupToolbar () {
      this.$store.dispatch('setTitle', {title: this.title})
      this.$store.dispatch('Action/setActions', this.actions)
    },
    gotoPage (page) {
      this.page = page
      this._doFiltering()
    },
    _doFiltering () {
      this.loaded = false
      this.$backend.businessTripRequestEmployee.getUnreleaseBtRequestFundsUsingGET({
        page: this.page - 1,
        impokey: this.filterData.impositionName,
        empkey: this.filterData.employeeName,
        size: this.paginationSize
      }).then(res => {
        if (this.page > res.body.totalPages && res.body.totalPages > 0) {
          this.page = 1
          this._doFiltering()
        } else {
          this.pagination = res.body
          for (let key in this.pagination.content) {
            let obj = this.pagination.content[key]
            obj.fromdatef = moment(obj.fromDate).format('DD MMM YYYY')
            obj.todatef = moment(obj.toDate).format('DD MMM YYYY')
          }
          this.loaded = true
        }
      }).catch(err => {
        this.$error(err)
      })
    },
    updateRelaseFund () {
      this.selecteditem.receivedFund = false
      this.selecteditem.receivedFundDate = null
      this.selecteditem.receivedFundNote = null
      this.selecteditem.receivedFundTotal = 0
      this.$backend.businessTripRequestEmployee.updateBtRequestEmployeeUsingPUT(
        {
          id: this.selecteditem.sppd.id,
          empid: this.selecteditem.id,
          emp: this.selecteditem
        })
        .then(res => {
          this.dialogS = false
          this.loadData()
          this._getUnreleaseData()
        })
        .catch(err => {
          this.$error(err)
        })
    },
    _getUnreleaseData () {
      this.getEmployeeRealizationsByOrg({vueinstance: this, orgid: '003'})
        .then(res => {
          this.unreleaseData = res
        })
        .catch(err => this.$error(err))
    },
    getUnreleaseData: _.debounce(function () { this._getUnreleaseData() }, 500),
    doFiltering: _.debounce(function () { this._doFiltering() }, 500),
    setPaginationSize (value) {
      this.$store.dispatch('setPaginationSize', {size: value, func: this.doFiltering})
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm._setupToolbar()
      vm.loadData()
    })
  }
}
</script>
<style scoped>
.p-lt-10px{
  padding: 15px 15px 0px 15px
}
</style>



// WEBPACK FOOTER //
// src/components/bt-unreleasefunds/BT-UnreleaseFunds.vue